import React from 'react';
import * as LucideIcons from 'lucide-react';

const OverviewSection = ({ content }) => {
  if (!content) return null;

  return (
    <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {content.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-amber-500 mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {content.sections.map((section, index) => {
            const IconComponent = LucideIcons[section.icon];
            return (
              <a
                key={index}
                href={section.link}
                className="group relative bg-white rounded-2xl p-8 text-center hover:shadow-2xl transition-all duration-300 border border-slate-200 hover:border-blue-300 hover:-translate-y-2"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-50 to-amber-50 rounded-xl mb-4 group-hover:scale-110 transition-transform duration-300">
                  {IconComponent && (
                    <IconComponent className="w-8 h-8 text-blue-600" />
                  )}
                </div>
                <h3 className="text-lg font-semibold text-slate-900 group-hover:text-blue-600 transition-colors">
                  {section.name}
                </h3>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
